// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import type { ToastsRenderer } from '@iheartjane/reefer';
import { Flex } from '@iheartjane/reefer';

import { Toast } from './Toast';

const ToastsWrapper = styled(Flex)({
  transform: 'translateX(-50%)',
});

export const Toasts = ({ remove, toasts }: ToastsRenderer) => (
  <ToastsWrapper
    alignItems="center"
    flexDirection="column"
    justifyContent="center"
    left="50%"
    overflow="hidden"
    position="fixed"
    top={24}
    zIndex="var(--layers-toast)"
  >
    {toasts.map((toast) => (
      <Toast key={toast.id} onClose={remove} {...toast} />
    ))}
  </ToastsWrapper>
);
